/**
 * OpenAI models supported for Website Builder AI generation.
 * Default favors quality + reliable structured JSON for full-site specs.
 */
export const WEBSITE_AI_INTEGRATION_DEFAULT = 'integration_default';
/** Best default for first-pass website generation (structured JSON, copy quality). */
export const WEBSITE_AI_RECOMMENDED_MODEL = 'gpt-4.1';
export const WEBSITE_AI_MODEL_OPTIONS = [
    {
        id: 'gpt-4.1',
        label: 'GPT-4.1',
        description: 'Best quality for copy, layout planning, and JSON site specs (recommended).',
        tier: 'best'
    },
    {
        id: 'gpt-4o',
        label: 'GPT-4o',
        description: 'Strong quality with large context; good balance of speed and output.',
        tier: 'balanced'
    },
    {
        id: 'gpt-4-turbo',
        label: 'GPT-4 Turbo',
        description: 'Reliable for complex instructions; slightly older than 4.1/4o.',
        tier: 'balanced'
    },
    {
        id: 'gpt-4o-mini',
        label: 'GPT-4o Mini',
        description: 'Faster and cheaper; may need more edits after generation.',
        tier: 'economy'
    },
    {
        id: 'gpt-4',
        label: 'GPT-4',
        description: 'Legacy model; use only if your API key does not support newer models.',
        tier: 'legacy'
    }
];
export const WEBSITE_AI_MODEL_IDS = WEBSITE_AI_MODEL_OPTIONS.map((m) => m.id);
const MODEL_ID_SET = new Set(WEBSITE_AI_MODEL_IDS);
export function isWebsiteAiModelId(value) {
    return MODEL_ID_SET.has(value);
}
/**
 * Resolve which OpenAI model id to use for a website generation job.
 */
export function resolveWebsiteGenerationModel(requestModel, integrationDefaultModel) {
    if (requestModel === WEBSITE_AI_INTEGRATION_DEFAULT) {
        const fromIntegration = integrationDefaultModel?.trim();
        if (fromIntegration && (MODEL_ID_SET.has(fromIntegration) || fromIntegration.startsWith('gpt-'))) {
            return fromIntegration;
        }
        return WEBSITE_AI_RECOMMENDED_MODEL;
    }
    if (requestModel && isWebsiteAiModelId(requestModel)) {
        return requestModel;
    }
    return WEBSITE_AI_RECOMMENDED_MODEL;
}
export function getWebsiteAiModelLabel(modelId) {
    const found = WEBSITE_AI_MODEL_OPTIONS.find((m) => m.id === modelId);
    return found?.label ?? modelId;
}
//# sourceMappingURL=websiteAiModels.js.map